<nav
  class="navbar fixed-top navbar-expand-lg navbar-dark white-background scrolling-navbar box-shadow navbar-height" 
>
  <div class="container loggedin no-padding-right-loggin" [ngClass]="{ 'mx-wd-tablet-desktop ml-auto mr-auto': !isAcmic }">
    <div class="brand">
      <a routerLink="/my-insurance">
        <ng-container *ngIf="isAcmic; else otherStateLogo">
              <div class="acmic-logo">
                <img src="./assets/img/images/logos/Group 1.svg" alt="AAA Insurance" class="acmic-new-logo" />
                <div class="acmic-header-text">
                  <img class="acmic-accordian" src="assets/img/images/Untitled.svg">
                  <span class="acmic-header-new">My account</span>
                </div>
              </div>
          </ng-container>
          <ng-template #otherStateLogo>
              <img src="assets/public/images/mapfre-logo.svg" alt="Mapfre Insurance" class="logo" />
          </ng-template>
        </a>
        <ng-container *ngIf="!isAcmic">
          <img class="ml-3 mr-3 seperation-w-h hide-in-mobile" src="assets/img/images/seperation-icon.svg">
          <img class="hide-in-desktop seperation-mr" src="assets/img/images/seperation-icon-mobile.svg">
          <span class="header-logo-text">My account</span>
        </ng-container>
    </div>
    <ng-container *ngIf="!policiesNotFound">    
    <div class="navbar-nav nav-flex-icons">
      <mapfre-modal 
        [modalOptions]="headerAccountModalOptions"
        [hideModal]="hideModalOnRoute"
        (openModal)="onOpenModal()"
        (modalHide)="onModalHide()"
        [loggedinHeaderModal]="true"
        (hideModalOutput)="resetHideModal()">
        <div class="modal-body no-margin-top margin-bottom">
          <hr class="no-margin-bottom " />
        </div>
        <a 
          routerLink="/profile"
          routerLinkActive="active"
          class="modal-footer brand-blue-secondary"
          (click)="hideModalAction()">
          <div class="mapfre-information-container">
            <div class="mapfre-icon-information row">
              <div class="padding-horizontal ph16 w-100">
                <div class="icon-container align-middle">
                    <ng-container *ngIf="isAcmic; else otherStateProfile">
                        <!-- <img src="assets/img/images/profile-icon-blue.svg" alt="profile icon"/> -->
                        <img src="assets/img/images/profile-icon-grey.svg" alt="profile icon"/>
                    </ng-container>
                    <ng-template #otherStateProfile>
                        <img src="assets/img/images/icon-account.svg" alt="profile icon"/>
                    </ng-template>
                    
                </div>
                <div class="information-container">
                  {{ 'PROFILE_AND_SETTINGS' | translate }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="!isAcmic">
            <img src="assets/img/images/icon-simple-arrow-right.svg" alt="right arrow icon"/>
          </div> -->
        </a> 
        <a
        routerLink="/my-insurance/link-policy"
        routerLinkActive="active"
        class="modal-footer brand-blue-secondary"
        (click)="hideModalAction()">
          <div class="mapfre-information-container">
            <div class="mapfre-icon-information row">
              <div class="padding-horizontal ph16 w-100">
                <div class="icon-container align-middle">
                    <ng-container *ngIf="isAcmic; else otherStateAddPolicy">
                        <img src="assets/img/images/plus-circle-icon-grey.svg" alt="add policy"/>
                    </ng-container>
                    <ng-template #otherStateAddPolicy>
                        <img src="assets/img/images/icon-other-products.svg" alt="add policy"/>
                    </ng-template>
                  
                </div>
                <div class="information-container">
                  {{ 'ADD_POLICY' | translate }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="!isAcmic">
            <img src="assets/img/images/icon-simple-arrow-right.svg" alt="right arrow icon"/>
          </div> -->
        </a> 
        <a class="modal-footer brand-blue-secondary" (click)="logout()">
          <div class="mapfre-information-container">
            <div class="mapfre-icon-information row">
              <div class="padding-horizontal ph16 w-100">
                <div class="icon-container align-middle">
                    <ng-container *ngIf="isAcmic; else otherStateLogout">
                        <img src="assets/img/images/profile-logout-icon-grey.svg" alt="logout icon"/>
                    </ng-container>
                    <ng-template #otherStateLogout>
                      <!-- <img src="assets/img/images/icon-logout.svg" alt="logout icon"/> -->
                      <img src="assets/img/images/icon-log-out.svg" alt="logout icon"/>
                    </ng-template>
                    
                </div>
                <div class="information-container">
                  {{ 'LOGOUT' | translate }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="!isAcmic">
            <img src="assets/img/images/icon-simple-arrow-right.svg" alt="right arrow icon"/>
          </div> -->
        </a>
      </mapfre-modal>
    </div>
  </ng-container>
  <ng-container *ngIf="policiesNotFound">
      <a 
      routerLinkActive="active"
      class="modal-footer brand-red-color no-policy-footer"
      (click)="logout()">
      <ng-container *ngIf="isAcmic; else otherStateLogOutImg">
        <span class="logout-txt mr-2 logout-acmic-text">Logout</span>
        <img src="assets/img/images/acmic/icon-log-out-black.svg" alt="policy logout acmic icon"/>
      </ng-container>
      <ng-template #otherStateLogOutImg>
        <img src="assets/img/images/icon-logout.svg" alt="policy logout ma icon"/>
        <span class="logout-txt">Logout</span>
      </ng-template>
    </a>
  </ng-container>
  </div>
</nav>
